import { render } from "./CardPlaceholder.vue?vue&type=template&id=525b7063"
import script from "./CardPlaceholder.vue?vue&type=script&lang=js"
export * from "./CardPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__